module.exports = __webpack_public_path__ + "static/images/email-sent.d233d9662be4d5fc34e79fdeae1d2822.svg";